// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10wD3","title":"styles_title__3P_zz"};